import PromisePolyfill from 'promise-polyfill';
import { assetsPath } from '../../utils/constants';

const { document } = window;
const { head } = document;
const P = window.Promise || PromisePolyfill;
const isProduction = process.env.NODE_ENV === 'production';
const cachebuster = Math.round(new Date().getTime() / 1000);

function bustCache(src) {
  return isProduction ? src : `${src}?cb=${cachebuster}`;
}

function once(fn) {
  let result;
  return (...args) => {
    if (!result) {
      result = fn(...args);
    }
    return result;
  };
}

function load(src) {
  if (!src) P.resolve();
  return new P((resolve) => {
    const script = document.createElement('script');
    script.src = bustCache(src);
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = resolve;
    head.appendChild(script);
  });
}

export function loadMany(resources) {
  const requests = resources.map(load);
  return P.all(requests);
}

const commonLibPath =
  window.assetsPath && isProduction
    ? `${assetsPath}/lmn-common-lib-ui/${process.env.COMMON_LIB_VERSION}/`
    : window.publicPath;

export function preLoad(src) {
  if (!src) return;
  const link = document.createElement('link');
  link.href = bustCache(src);
  link.as = 'script';
  link.rel = 'preload';
  link.crossOrigin = 'anonymous';
  head.appendChild(link);
}

export function preFetch(src) {
  if (!src) return;
  const link = document.createElement('link');
  link.href = bustCache(src);
  link.as = 'script';
  link.rel = 'prefetch';
  head.appendChild(link);
}

export const firstChunk = [
  `${window.publicPath}obe-ui.bundle.vendors.0.js`,
  `${window.publicPath}obe-ui.bundle.vendors.1.js`,
];

export const secondChunk = [`${commonLibPath}mobx_react.js`, `${commonLibPath}react_i18n.js`];

export const BUNDLES = {
  UTILS: `${window.publicPath}obe-ui.utils.js`,
  APP: `${window.publicPath}obe-ui.app.js`,
  LOGGER: `${window.publicPath}obe-ui.consoleLogger.js`,
};

const loadVendors = once(() => loadMany(firstChunk).then(() => loadMany(secondChunk)));

export function createScriptLoader(src) {
  preLoad(src);
  const loadResources = () => loadVendors().then(() => load(src));
  return (...dependencies) => P.all([loadResources(), ...dependencies]).then(([, ...others]) => others);
}
